const appconfig = {
    colors: {
        primaryBg: 'bg-neutral-200',
        primaryBorder: 'border-neutral-200',
        secondary: '#6c757d',
        success: '#198754',
        info: '#0dcaf0',
        warning: '#ffc107',
        dangerText: 'text-[red]',
        light: '#f8f9fa',
        dark: '#212529',
        text: '#777777',
        headerText: 'bg-gray-400',
        buttonPrimary: 'bg-[#A3C159]',
        // buttonPrimary: 'bg-[#ffbf00]',
        buttonSecondary: 'bg-gray-400',
        coloredSection: 'bg-[#A3C159]',
        coloredSectionBorder: 'border-[#A3C159]',
        coloredSectionlight: 'bg-[#e1e8e1]',
        coloredSectionText: 'text-[#A3C159]',
        coloredSectionFrom: 'from-[#A3C159]',
        // coloredSection: 'bg-[#ffbf00]',
    },
    name: 'Penny Car Hire',
    description: 'Penny Car Hire',
    collectionTimeStart: 8,
    collectionTimeEnd: 18,
    maxSiteWidth: 'max-w-[1100px] mx-auto w-full',
};

export default appconfig;
